import { Flex, Spinner } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Customers from "./CustomerTable";
import BasicLayout from "../../components/Layouts/BasicLayout";
import { getCustomers } from "../../store/actions/customer/customer.action";

const Customer = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    dispatch(getCustomers())
      .then((resp) => {
        setIsLoading(false);
        setCustomers(resp);
      })
      .catch((err) => setIsLoading(false));
  }, [dispatch]);

  if (isLoading) {
    return (
      <Flex h="100vh" w="100vw" justify="center" align="center">
        <Spinner />
      </Flex>
    );
  }

  return (
    <BasicLayout>
      <Customers customers={customers}></Customers>
    </BasicLayout>
  );
};

export default Customer;